import { render, staticRenderFns } from "./ReactionOverview.vue?vue&type=template&id=5e4fdc3c"
import script from "./ReactionOverview.vue?vue&type=script&lang=js"
export * from "./ReactionOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports